export const MenuList = [
	// Dashboard
	// {
	// 	title: "Dashboard",
	// 	classsChange: "mm-collapse",
	// 	iconActive: (
	// 		<svg
	// 			width="24"
	// 			height="24"
	// 			viewBox="0 0 24 24"
	// 			fill="none"
	// 			xmlns="http://www.w3.org/2000/svg">
	// 			<path
	// 				d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
	// 				fill="white"
	// 			/>
	// 			<path
	// 				d="M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z"
	// 				fill="white"
	// 			/>
	// 			<path
	// 				d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
	// 				fill="white"
	// 			/>
	// 			<path
	// 				d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
	// 				fill="white"
	// 			/>
	// 		</svg>
	// 	),
	// 	iconDeactive: (
	// 		<svg
	// 			width="24"
	// 			height="24"
	// 			viewBox="0 0 24 24"
	// 			fill="none"
	// 			xmlns="http://www.w3.org/2000/svg">
	// 			<path
	// 				d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
	// 				fill="#7B7B7B"
	// 			/>
	// 			<path
	// 				d="M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z"
	// 				fill="#7B7B7B"
	// 			/>
	// 			<path
	// 				d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
	// 				fill="#7B7B7B"
	// 			/>
	// 			<path
	// 				d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
	// 				fill="#7B7B7B"
	// 			/>
	// 		</svg>
	// 	),
	// 	to: "",
	// 	text: "dashboard",
	// },

	// Admins
	{
		title: "Admins",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M18 2H6C4.34 2 3 3.33 3 4.97V15.88C3 17.52 4.34 18.85 6 18.85H6.76C7.56 18.85 8.32 19.16 8.88 19.72L10.59 21.41C11.37 22.18 12.64 22.18 13.42 21.41L15.13 19.72C15.69 19.16 16.46 18.85 17.25 18.85H18C19.66 18.85 21 17.52 21 15.88V4.97C21 3.33 19.66 2 18 2ZM12 5.75C13.29 5.75 14.33 6.79 14.33 8.08C14.33 9.37 13.29 10.41 12 10.41C10.71 10.41 9.67 9.36 9.67 8.08C9.67 6.79 10.71 5.75 12 5.75ZM14.68 15.06H9.32C8.51 15.06 8.04 14.16 8.49 13.49C9.17 12.48 10.49 11.8 12 11.8C13.51 11.8 14.83 12.48 15.51 13.49C15.96 14.16 15.48 15.06 14.68 15.06Z"
					fill="white"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M17.53 7.77C17.46 7.76 17.39 7.76 17.32 7.77C15.77 7.72 14.54 6.45 14.54 4.89C14.54 3.3 15.83 2 17.43 2C19.02 2 20.32 3.29 20.32 4.89C20.31 6.45 19.08 7.72 17.53 7.77Z"
					fill="#7B7B7B"
				/>
				<path
					d="M20.79 14.7C19.67 15.45 18.1 15.73 16.65 15.54C17.03 14.72 17.23 13.81 17.24 12.85C17.24 11.85 17.02 10.9 16.6 10.07C18.08 9.87004 19.65 10.15 20.78 10.9C22.36 11.94 22.36 13.65 20.79 14.7Z"
					fill="#7B7B7B"
				/>
				<path
					d="M6.44 7.77C6.51 7.76 6.58 7.76 6.65 7.77C8.2 7.72 9.43 6.45 9.43 4.89C9.43 3.29 8.14 2 6.54 2C4.95 2 3.66 3.29 3.66 4.89C3.66 6.45 4.89 7.72 6.44 7.77Z"
					fill="#7B7B7B"
				/>
				<path
					d="M6.55 12.85C6.55 13.82 6.75999 14.74 7.14 15.57C5.73 15.72 4.26 15.42 3.18 14.71C1.6 13.66 1.6 11.95 3.18 10.9C4.25 10.18 5.75999 9.88998 7.18 10.05C6.77 10.89 6.55 11.84 6.55 12.85Z"
					fill="#7B7B7B"
				/>
				<path
					d="M12.12 15.87C12.04 15.86 11.95 15.86 11.86 15.87C10.02 15.81 8.55 14.3 8.55 12.44C8.56 10.54 10.09 9 12 9C13.9 9 15.44 10.54 15.44 12.44C15.43 14.3 13.97 15.81 12.12 15.87Z"
					fill="#7B7B7B"
				/>
				<path
					d="M8.87 17.94C7.36 18.95 7.36 20.61 8.87 21.61C10.59 22.76 13.41 22.76 15.13 21.61C16.64 20.6 16.64 18.94 15.13 17.94C13.42 16.79 10.6 16.79 8.87 17.94Z"
					fill="#7B7B7B"
				/>
			</svg>
		),
		to: "",
		text: "admins",
	},

	// Home
	{
		title: "Home",
		classsChange: "mm-collapse",
		iconActive: (
			<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					strokeLinecap="round"
					strokeLinejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<path
						d="M22 22L2 22"
						stroke="#FFFFFF"
						strokeWidth="1.5"
						strokeLinecap="round"></path>{" "}
					<path
						d="M2 11L10.1259 4.49931C11.2216 3.62279 12.7784 3.62279 13.8741 4.49931L22 11"
						stroke="#FFFFFF"
						strokeWidth="1.5"
						strokeLinecap="round"></path>{" "}
					<path
						opacity="0.5"
						d="M15.5 5.5V3.5C15.5 3.22386 15.7239 3 16 3H18.5C18.7761 3 19 3.22386 19 3.5V8.5"
						stroke="#FFFFFF"
						strokeWidth="1.5"
						strokeLinecap="round"></path>{" "}
					<path
						d="M4 22V9.5"
						stroke="#FFFFFF"
						strokeWidth="1.5"
						strokeLinecap="round"></path>{" "}
					<path
						d="M20 22V9.5"
						stroke="#FFFFFF"
						strokeWidth="1.5"
						strokeLinecap="round"></path>{" "}
					<path
						opacity="0.5"
						d="M15 22V17C15 15.5858 15 14.8787 14.5607 14.4393C14.1213 14 13.4142 14 12 14C10.5858 14 9.87868 14 9.43934 14.4393C9 14.8787 9 15.5858 9 17V22"
						stroke="#FFFFFF"
						strokeWidth="1.5"></path>{" "}
					<path
						opacity="0.5"
						d="M14 9.5C14 10.6046 13.1046 11.5 12 11.5C10.8954 11.5 10 10.6046 10 9.5C10 8.39543 10.8954 7.5 12 7.5C13.1046 7.5 14 8.39543 14 9.5Z"
						stroke="#FFFFFF"
						strokeWidth="1.5"></path>{" "}
				</g>
			</svg>
		),
		iconDeactive: (
			<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					strokeLinecap="round"
					strokeLinejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<path
						d="M22 22L2 22"
						stroke="#7B7B7B"
						strokeWidth="1.5"
						strokeLinecap="round"></path>{" "}
					<path
						d="M2 11L10.1259 4.49931C11.2216 3.62279 12.7784 3.62279 13.8741 4.49931L22 11"
						stroke="#7B7B7B"
						strokeWidth="1.5"
						strokeLinecap="round"></path>{" "}
					<path
						opacity="0.5"
						d="M15.5 5.5V3.5C15.5 3.22386 15.7239 3 16 3H18.5C18.7761 3 19 3.22386 19 3.5V8.5"
						stroke="#7B7B7B"
						strokeWidth="1.5"
						strokeLinecap="round"></path>{" "}
					<path
						d="M4 22V9.5"
						stroke="#7B7B7B"
						strokeWidth="1.5"
						strokeLinecap="round"></path>{" "}
					<path
						d="M20 22V9.5"
						stroke="#7B7B7B"
						strokeWidth="1.5"
						strokeLinecap="round"></path>{" "}
					<path
						opacity="0.5"
						d="M15 22V17C15 15.5858 15 14.8787 14.5607 14.4393C14.1213 14 13.4142 14 12 14C10.5858 14 9.87868 14 9.43934 14.4393C9 14.8787 9 15.5858 9 17V22"
						stroke="#7B7B7B"
						strokeWidth="1.5"></path>{" "}
					<path
						opacity="0.5"
						d="M14 9.5C14 10.6046 13.1046 11.5 12 11.5C10.8954 11.5 10 10.6046 10 9.5C10 8.39543 10.8954 7.5 12 7.5C13.1046 7.5 14 8.39543 14 9.5Z"
						stroke="#7B7B7B"
						strokeWidth="1.5"></path>{" "}
				</g>
			</svg>
		),
		text: "home",
		to: "home",
	},

	// Projects
	{
		title: "Projects",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M16 2H8C4.5 2 3 4 3 7V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V7C21 4 19.5 2 16 2ZM8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25ZM16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75ZM18.5 9.25H16.5C14.98 9.25 13.75 8.02 13.75 6.5V4.5C13.75 4.09 14.09 3.75 14.5 3.75C14.91 3.75 15.25 4.09 15.25 4.5V6.5C15.25 7.19 15.81 7.75 16.5 7.75H18.5C18.91 7.75 19.25 8.09 19.25 8.5C19.25 8.91 18.91 9.25 18.5 9.25Z"
					fill="#FFFFFF"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M16 2H8C4.5 2 3 4 3 7V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V7C21 4 19.5 2 16 2ZM8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25ZM16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75ZM18.5 9.25H16.5C14.98 9.25 13.75 8.02 13.75 6.5V4.5C13.75 4.09 14.09 3.75 14.5 3.75C14.91 3.75 15.25 4.09 15.25 4.5V6.5C15.25 7.19 15.81 7.75 16.5 7.75H18.5C18.91 7.75 19.25 8.09 19.25 8.5C19.25 8.91 18.91 9.25 18.5 9.25Z"
					fill="#7B7B7B"
				/>
			</svg>
		),
		text: "projects",
		to: "projects",
	},

	// Media Center
	{
		title: "Media Center",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				viewBox="0 0 32 32"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xlink="http://www.w3.org/1999/xlink"
				fill="#FFFFFF">
				<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					strokeLinecap="round"
					strokeLinejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<g id="icomoon-ignore"> </g>{" "}
					<path
						d="M9.069 2.672v14.928h-6.397c0 0 0 6.589 0 8.718s1.983 3.010 3.452 3.010c1.469 0 16.26 0 20.006 0 1.616 0 3.199-1.572 3.199-3.199 0-1.175 0-23.457 0-23.457h-20.259zM6.124 28.262c-0.664 0-2.385-0.349-2.385-1.944v-7.652h5.331v7.192c0 0.714-0.933 2.404-2.404 2.404h-0.542zM28.262 26.129c0 1.036-1.096 2.133-2.133 2.133h-17.113c0.718-0.748 1.119-1.731 1.119-2.404v-22.12h18.126v22.391z"
						fill="#FFFFFF">
						{" "}
					</path>{" "}
					<path d="M12.268 5.871h13.861v1.066h-13.861v-1.066z" fill="#FFFFFF">
						{" "}
					</path>{" "}
					<path d="M12.268 20.265h13.861v1.066h-13.861v-1.066z" fill="#FFFFFF">
						{" "}
					</path>{" "}
					<path d="M12.268 23.997h13.861v1.066h-13.861v-1.066z" fill="#FFFFFF">
						{" "}
					</path>{" "}
					<path
						d="M26.129 9.602h-13.861v7.997h13.861v-7.997zM25.063 16.533h-11.729v-5.864h11.729v5.864z"
						fill="#FFFFFF">
						{" "}
					</path>{" "}
				</g>
			</svg>
		),
		iconDeactive: (
			<svg
				viewBox="0 0 32 32"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xlink="http://www.w3.org/1999/xlink"
				fill="#7B7B7B">
				<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					strokeLinecap="round"
					strokeLinejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<g id="icomoon-ignore"> </g>{" "}
					<path
						d="M9.069 2.672v14.928h-6.397c0 0 0 6.589 0 8.718s1.983 3.010 3.452 3.010c1.469 0 16.26 0 20.006 0 1.616 0 3.199-1.572 3.199-3.199 0-1.175 0-23.457 0-23.457h-20.259zM6.124 28.262c-0.664 0-2.385-0.349-2.385-1.944v-7.652h5.331v7.192c0 0.714-0.933 2.404-2.404 2.404h-0.542zM28.262 26.129c0 1.036-1.096 2.133-2.133 2.133h-17.113c0.718-0.748 1.119-1.731 1.119-2.404v-22.12h18.126v22.391z"
						fill="#7B7B7B">
						{" "}
					</path>{" "}
					<path d="M12.268 5.871h13.861v1.066h-13.861v-1.066z" fill="#7B7B7B">
						{" "}
					</path>{" "}
					<path d="M12.268 20.265h13.861v1.066h-13.861v-1.066z" fill="#7B7B7B">
						{" "}
					</path>{" "}
					<path d="M12.268 23.997h13.861v1.066h-13.861v-1.066z" fill="#7B7B7B">
						{" "}
					</path>{" "}
					<path
						d="M26.129 9.602h-13.861v7.997h13.861v-7.997zM25.063 16.533h-11.729v-5.864h11.729v5.864z"
						fill="#7B7B7B">
						{" "}
					</path>{" "}
				</g>
			</svg>
		),
		text: "media_center",
		to: "media-center",
	},
	// leadership and Our Board
	{
		title: "leadership and Our Board",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				fill="#FFFFFF"
				version="1.1"
				id="Capa_1"
				xmlns="http://www.w3.org/2000/svg"
				xlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 57.001 57.001"
				space="preserve">
				<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					strokeLinecap="round"
					strokeLinejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<g>
						{" "}
						<g> </g>{" "}
						<g>
							{" "}
							<path d="M39,13.001c3.309,0,6-2.691,6-6s-2.691-6-6-6s-6,2.691-6,6S35.691,13.001,39,13.001z M39,3.001c2.206,0,4,1.794,4,4 s-1.794,4-4,4c-0.117,0-0.226-0.025-0.34-0.034C39.476,10.234,40,9.182,40,8.001h-2c0,0.986-0.719,1.803-1.66,1.966 C35.524,9.234,35,8.182,35,7.001C35,4.795,36.794,3.001,39,3.001z"></path>{" "}
							<path d="M8,25.001c3.309,0,6-2.691,6-6s-2.691-6-6-6s-6,2.691-6,6S4.691,25.001,8,25.001z M8,15.001c2.206,0,4,1.794,4,4 c0,1.181-0.524,2.233-1.34,2.966C9.719,21.804,9,20.987,9,20.001H7c0,1.181,0.524,2.233,1.34,2.966 C8.226,22.976,8.117,23.001,8,23.001c-2.206,0-4-1.794-4-4S5.794,15.001,8,15.001z"></path>{" "}
							<path d="M56.316,2.053l-6-2c-0.306-0.104-0.639-0.052-0.901,0.136C49.154,0.378,49,0.68,49,1.001v8v5H35 c-0.234,0-0.461,0.082-0.641,0.231l-6,5c-0.105,0.089-0.192,0.198-0.254,0.321l-2.836,5.673l-6.314,2.705l-5.639-1.879 c-0.102-0.033-0.209-0.051-0.316-0.051H5c-2.757,0-5,2.243-5,5v11c0,0.553,0.447,1,1,1h3v12H0v2h5h5h4c0.553,0,1-0.447,1-1v-5h2h5 h7c0.553,0,1-0.447,1-1v-5h6h5c0.553,0,1-0.447,1-1v-5h6h5h3v-2h-2v-8c0-2.757-2.243-5-5-5h-4v-4h5c2.757,0,5-2.243,5-5v-6 c0-0.553-0.447-1-1-1h-3V5.722l5.316-1.772C56.725,3.813,57,3.432,57,3.001S56.725,2.189,56.316,2.053z M40.523,16.001L40,17.309 l-0.523-1.308H40.523z M14,49.001c-0.553,0-1,0.447-1,1v5h-2v-12h5v6H14z M18,49.001v-7c0-0.553-0.447-1-1-1h-7 c-0.553,0-1,0.447-1,1v13H6v-23H4v9H2v-10c0-1.654,1.346-3,3-3h3v7h2v-7h2.838l5.846,1.948c0.232,0.079,0.486,0.066,0.71-0.029 l6.235-2.672l0.607,0.91l0.303,0.455l-6.708,3.353l-6.69-0.956c-0.287-0.042-0.578,0.045-0.797,0.234 C12.126,31.436,12,31.711,12,32.001v5c0,0.553,0.447,1,1,1h5c1.654,0,3,1.346,3,3v8H18z M29,43.001c-0.553,0-1,0.447-1,1v5h-5v-8 c0-2.757-2.243-5-5-5h-4v-2.847l5.858,0.837c0.202,0.029,0.406-0.005,0.589-0.096l8-4c0.146-0.073,0.261-0.184,0.354-0.313 c0.008-0.011,0.023-0.015,0.031-0.026l3.905-5.857L35,22.001v21H29z M47,37.001h-5v-6h5V37.001z M53,15.001c0,1.654-1.346,3-3,3 h-6c-0.553,0-1,0.447-1,1v6c0,0.553,0.447,1,1,1h5c1.654,0,3,1.346,3,3v8h-3v-7c0-0.553-0.447-1-1-1h-7c-0.553,0-1,0.447-1,1v8v5 h-3v-23c0-0.379-0.214-0.725-0.553-0.895c-0.338-0.168-0.745-0.133-1.047,0.095l-4,3c-0.091,0.067-0.17,0.15-0.232,0.245 L28,27.198l-0.846-1.27l2.646-5.293l5.562-4.634h1.961l1.748,4.371c0.153,0.38,0.52,0.629,0.929,0.629s0.776-0.249,0.929-0.629 l1.748-4.371H50c0.553,0,1-0.447,1-1v-5h2V15.001z M51,3.613V2.389l1.838,0.612L51,3.613z"></path>{" "}
							<rect x="24" y="5.001" width="2" height="2"></rect>{" "}
							<rect x="20" y="5.001" width="2" height="2"></rect>{" "}
							<rect x="16" y="5.001" width="2" height="2"></rect>{" "}
						</g>{" "}
					</g>{" "}
				</g>
			</svg>
		),
		iconDeactive: (
			<svg
				fill="#7B7B7B"
				version="1.1"
				id="Capa_1"
				xmlns="http://www.w3.org/2000/svg"
				xlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 57.001 57.001"
				space="preserve">
				<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					strokeLinecap="round"
					strokeLinejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<g>
						{" "}
						<g> </g>{" "}
						<g>
							{" "}
							<path d="M39,13.001c3.309,0,6-2.691,6-6s-2.691-6-6-6s-6,2.691-6,6S35.691,13.001,39,13.001z M39,3.001c2.206,0,4,1.794,4,4 s-1.794,4-4,4c-0.117,0-0.226-0.025-0.34-0.034C39.476,10.234,40,9.182,40,8.001h-2c0,0.986-0.719,1.803-1.66,1.966 C35.524,9.234,35,8.182,35,7.001C35,4.795,36.794,3.001,39,3.001z"></path>{" "}
							<path d="M8,25.001c3.309,0,6-2.691,6-6s-2.691-6-6-6s-6,2.691-6,6S4.691,25.001,8,25.001z M8,15.001c2.206,0,4,1.794,4,4 c0,1.181-0.524,2.233-1.34,2.966C9.719,21.804,9,20.987,9,20.001H7c0,1.181,0.524,2.233,1.34,2.966 C8.226,22.976,8.117,23.001,8,23.001c-2.206,0-4-1.794-4-4S5.794,15.001,8,15.001z"></path>{" "}
							<path d="M56.316,2.053l-6-2c-0.306-0.104-0.639-0.052-0.901,0.136C49.154,0.378,49,0.68,49,1.001v8v5H35 c-0.234,0-0.461,0.082-0.641,0.231l-6,5c-0.105,0.089-0.192,0.198-0.254,0.321l-2.836,5.673l-6.314,2.705l-5.639-1.879 c-0.102-0.033-0.209-0.051-0.316-0.051H5c-2.757,0-5,2.243-5,5v11c0,0.553,0.447,1,1,1h3v12H0v2h5h5h4c0.553,0,1-0.447,1-1v-5h2h5 h7c0.553,0,1-0.447,1-1v-5h6h5c0.553,0,1-0.447,1-1v-5h6h5h3v-2h-2v-8c0-2.757-2.243-5-5-5h-4v-4h5c2.757,0,5-2.243,5-5v-6 c0-0.553-0.447-1-1-1h-3V5.722l5.316-1.772C56.725,3.813,57,3.432,57,3.001S56.725,2.189,56.316,2.053z M40.523,16.001L40,17.309 l-0.523-1.308H40.523z M14,49.001c-0.553,0-1,0.447-1,1v5h-2v-12h5v6H14z M18,49.001v-7c0-0.553-0.447-1-1-1h-7 c-0.553,0-1,0.447-1,1v13H6v-23H4v9H2v-10c0-1.654,1.346-3,3-3h3v7h2v-7h2.838l5.846,1.948c0.232,0.079,0.486,0.066,0.71-0.029 l6.235-2.672l0.607,0.91l0.303,0.455l-6.708,3.353l-6.69-0.956c-0.287-0.042-0.578,0.045-0.797,0.234 C12.126,31.436,12,31.711,12,32.001v5c0,0.553,0.447,1,1,1h5c1.654,0,3,1.346,3,3v8H18z M29,43.001c-0.553,0-1,0.447-1,1v5h-5v-8 c0-2.757-2.243-5-5-5h-4v-2.847l5.858,0.837c0.202,0.029,0.406-0.005,0.589-0.096l8-4c0.146-0.073,0.261-0.184,0.354-0.313 c0.008-0.011,0.023-0.015,0.031-0.026l3.905-5.857L35,22.001v21H29z M47,37.001h-5v-6h5V37.001z M53,15.001c0,1.654-1.346,3-3,3 h-6c-0.553,0-1,0.447-1,1v6c0,0.553,0.447,1,1,1h5c1.654,0,3,1.346,3,3v8h-3v-7c0-0.553-0.447-1-1-1h-7c-0.553,0-1,0.447-1,1v8v5 h-3v-23c0-0.379-0.214-0.725-0.553-0.895c-0.338-0.168-0.745-0.133-1.047,0.095l-4,3c-0.091,0.067-0.17,0.15-0.232,0.245 L28,27.198l-0.846-1.27l2.646-5.293l5.562-4.634h1.961l1.748,4.371c0.153,0.38,0.52,0.629,0.929,0.629s0.776-0.249,0.929-0.629 l1.748-4.371H50c0.553,0,1-0.447,1-1v-5h2V15.001z M51,3.613V2.389l1.838,0.612L51,3.613z"></path>{" "}
							<rect x="24" y="5.001" width="2" height="2"></rect>{" "}
							<rect x="20" y="5.001" width="2" height="2"></rect>{" "}
							<rect x="16" y="5.001" width="2" height="2"></rect>{" "}
						</g>{" "}
					</g>{" "}
				</g>
			</svg>
		),
		text: "leadership_ourboard",
		to: "leadership-ourboard",
	},
	// Contact Us
	{
		title: "Contact Us",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				fill="#FFFFFF"
				viewBox="0 0 64 64"
				version="1.1"
				space="preserve"
				xmlns="http://www.w3.org/2000/svg"
				xlink="http://www.w3.org/1999/xlink">
				<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					strokeLinecap="round"
					strokeLinejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<g id="_x32_5_attachment"></g> <g id="_x32_4_office"></g>{" "}
					<g id="_x32_3_pin"></g> <g id="_x32_2_business_card"></g>{" "}
					<g id="_x32_1_form"></g> <g id="_x32_0_headset"></g>{" "}
					<g id="_x31_9_video_call"></g> <g id="_x31_8_letter_box"></g>{" "}
					<g id="_x31_7_papperplane"></g> <g id="_x31_6_laptop"></g>{" "}
					<g id="_x31_5_connection"></g> <g id="_x31_4_phonebook"></g>{" "}
					<g id="_x31_3_classic_telephone"></g> <g id="_x31_2_sending_mail"></g>{" "}
					<g id="_x31_1_man_talking"></g> <g id="_x31_0_date"></g>{" "}
					<g id="_x30_9_review"></g> <g id="_x30_8_email"></g>{" "}
					<g id="_x30_7_information"></g> <g id="_x30_6_phone_talking"></g>{" "}
					<g id="_x30_5_women_talking">
						{" "}
						<g>
							{" "}
							<g>
								{" "}
								<path d="M24.8975,30.165c0.0488,0,0.0986-0.001,0.1484-0.0034c0.8809-0.0366,1.6865-0.3921,2.21-0.9751 c0.3691-0.4111,0.335-1.0435-0.0762-1.4121c-0.4111-0.3677-1.043-0.335-1.4121,0.0762c-0.1611,0.1792-0.4697,0.2988-0.8057,0.313 c-0.3975,0.02-0.7861-0.1191-1.0566-0.3726c-0.4004-0.3784-1.0342-0.3599-1.4131,0.0415 c-0.3789,0.4019-0.3604,1.0347,0.042,1.4136C23.1582,29.8345,24.0117,30.165,24.8975,30.165z"></path>{" "}
								<path d="M29.0557,22.8726c0.2705-0.2539,0.6621-0.3901,1.0576-0.3726c0.3359,0.0142,0.6436,0.1338,0.8047,0.3125 c0.1973,0.2202,0.4707,0.3325,0.7441,0.3325c0.2383,0,0.4766-0.0845,0.668-0.2554c0.4111-0.3691,0.4453-1.001,0.0762-1.4121 c-0.5225-0.5835-1.3281-0.939-2.21-0.9761c-0.9277-0.0288-1.8525,0.2949-2.5117,0.916c-0.4023,0.3789-0.4209,1.0117-0.042,1.4136 C28.0205,23.2329,28.6553,23.251,29.0557,22.8726z"></path>{" "}
								<path d="M20.1855,22.813c0.1973,0.2202,0.4707,0.332,0.7441,0.332c0.2383,0,0.4775-0.0845,0.668-0.2559 c0.4111-0.3691,0.4453-1.0015,0.0762-1.4121c-0.5244-0.584-1.332-0.9395-2.2158-0.9756 c-0.9473-0.0342-1.8516,0.2964-2.5078,0.9175c-0.4014,0.3794-0.418,1.0122-0.0391,1.4136 c0.3818,0.4019,1.0146,0.418,1.4141,0.0386c0.2666-0.2524,0.6309-0.3916,1.0518-0.3711 C19.7148,22.5137,20.0244,22.6338,20.1855,22.813z"></path>{" "}
								<path d="M45.2793,26.5942h-0.0381c-0.5527,0-0.9805,0.4478-0.9805,1s0.4658,1,1.0186,1s1-0.4478,1-1 S45.832,26.5942,45.2793,26.5942z"></path>{" "}
								<path d="M50.5283,26.5942h-0.0391c-0.5527,0-0.9805,0.4478-0.9805,1s0.4668,1,1.0195,1s1-0.4478,1-1 S51.0811,26.5942,50.5283,26.5942z"></path>{" "}
								<path d="M55.7803,26.5942h-0.0381c-0.5527,0-0.9814,0.4478-0.9814,1s0.4668,1,1.0195,1s1-0.4478,1-1 S56.333,26.5942,55.7803,26.5942z"></path>{" "}
								<path d="M59.28,20.01c-4.1-4.82-11.36-5.4-16.1801-1.3c-0.05,0.04-0.1,0.08-0.14,0.13c-1.15-4.68-3.1-9.47-6.39-12.92 C33.46,2.65,29.51,1,24.84,1C17.37,1,11.67,5.34,8.38,13.56c-3.49,8.7-3.41,20.04-1.87,21.51 c0.9384,0.8489,2.5365,1.6553,4.1448,2.2953c-8.6735,3.9588-8.6773,11.0029-8.6773,15.932V62c0,0.5522,0.4473,1,1,1H24.784 c0.001,0,0.0021,0.0005,0.0031,0.0005S46.6846,63,46.6846,63c0.5527,0,1-0.4478,1-1v-8.7026 c0-4.8027-0.0054-11.6125-8.0305-15.6208c1.2346-0.5417,2.4157-1.1508,3.2759-1.6266c1.85,1.65,4.18,2.64,6.7,2.85 c0.31,0.02,0.62,0.03,0.93,0.03c2.72,0,5.33-0.95,7.43-2.74c2.33-1.98,3.75-4.76,4-7.82C62.23,25.31,61.27,22.35,59.28,20.01z M10.6592,61v-4.8848c0-0.5522-0.4473-1-1-1s-1,0.4478-1,1V61H3.9775v-7.7026c0-5.4964,0.0034-12.2559,10.8652-15.3299 l-2.8193,5.1043c-0.2168,0.3916-0.1465,0.8799,0.1719,1.1943l3.1855,3.1494l-2.2578,5.7671 c-0.1611,0.4126-0.0322,0.8818,0.3184,1.1538L22.0166,61H10.6592z M15.2578,53.2158l2.2256-5.6846 c0.1455-0.3716,0.0557-0.7944-0.2285-1.0752l-3.1152-3.0801l2.4288-4.3976l6.3467,20.1876L15.2578,53.2158z M18.7599,34.2893 c1.8194,1.3416,3.8754,2.1711,6.0057,2.1711c1.9218,0,3.9115-0.8772,5.7386-2.2679l1.252,2.3571l-1.5366,4.8776H19.435 l-1.5521-4.937L18.7599,34.2893z M13.9375,21.4214v-3.8916c2.918-0.7085,3.6611-1.6431,4.8291-3.3809 c0.2959-0.4419,0.6221-0.9268,1.0488-1.4824c5.7842,3.3081,10.1367,4.6816,15.9268,5.0151v3.7607 c0,5.0225-5.9932,13.0181-10.9766,13.0181c-2.0349,0-4.023-0.9845-5.7318-2.5032c-0.0017-0.0017-0.0038-0.0029-0.0055-0.0046 C16.0564,29.3085,13.9375,25.0353,13.9375,21.4214z M20.0638,43.4272h9.5258l-4.7678,15.1341L20.0638,43.4272z M33.0797,39.0062 l2.4017,4.4459l-3.1201,3.084c-0.2842,0.2813-0.374,0.7041-0.2275,1.0762l2.2275,5.6846l-7.6577,5.9484L33.0797,39.0062z M45.6846,53.2974V61h-5.1035v-4.8848c0-0.5522-0.4473-1-1-1s-1,0.4478-1,1V61H27.7043l8.4744-6.5825 c0.3506-0.272,0.4795-0.7417,0.3174-1.1543l-2.2607-5.7676l3.1855-3.1479c0.3154-0.3125,0.3877-0.7959,0.1768-1.1865 l-2.8101-5.2013c0.6685,0.1884,1.2931,0.3917,1.8821,0.6069c0.0052,0.0018,0.0101,0.0038,0.0154,0.0054 C45.678,41.864,45.6846,48.1368,45.6846,53.2974z M36.9973,36.5634c-1.0552-0.3694-2.2184-0.6985-3.4925-0.9843l-1.4546-2.7385 c3.2595-3.1593,5.692-7.7846,5.692-11.3983v-4.7148c0-0.5376-0.4258-0.9795-0.9629-0.9995 c-6.1631-0.2295-10.5332-1.5957-16.6992-5.2202c-0.4209-0.2476-0.9609-0.1548-1.2734,0.2207 c-0.7725,0.9224-1.2871,1.689-1.7012,2.3052c-1.0615,1.5806-1.4189,2.1133-4.3672,2.7139 c-0.4658,0.0952-0.8008,0.5049-0.8008,0.98v4.6938c0,3.9083,2.1079,8.4235,5.2225,11.4815l-1.0725,2.6915 c-0.8946,0.2024-1.7331,0.4266-2.5178,0.6714C11.192,35.5442,8.8646,34.4692,7.93,33.66c-0.78-1.58-1.12-14,3.93-22.72 C14.91,5.67,19.28,3,24.84,3c4.1,0,7.56,1.44,10.28,4.29c3.3,3.46,5.15,8.53,6.18,13.36c-1.7,2.29-2.48,5.14-2.17,8.03 l-2.59,3.51c-0.23,0.3-0.2599,0.7-0.1,1.03c0.16,0.34,0.5,0.55,0.87,0.56l3.72,0.1c0.15,0.23,0.3199,0.45,0.49,0.66 C40.2336,35.2254,38.497,36.0573,36.9973,36.5634z M59.99,28.21c-0.1,1.27-0.44,2.47-1,3.56c-0.56,1.1-1.33,2.08-2.3,2.9 c-1.93,1.64-4.37,2.44-6.9,2.23c-1.97-0.16-3.79-0.9-5.27-2.13c-0.8106-0.6598-1.56-1.4893-2.08-2.4 c-0.18-0.29-0.49-0.46-0.83-0.47l-2.32-0.07l1.68-2.28c0.16-0.21,0.23-0.48,0.19-0.74c-0.2599-1.78-0.0099-3.55,0.69-5.14 c0.39-0.91,0.94-1.76,1.62-2.52c0.28-0.32,0.6-0.63,0.9301-0.91c3.98-3.39,9.97-2.91,13.36,1.07 C59.4,23.24,60.19,25.69,59.99,28.21z"></path>{" "}
							</g>{" "}
						</g>{" "}
					</g>{" "}
					<g id="_x30_4_calling"></g> <g id="_x30_3_women"></g>{" "}
					<g id="_x30_2_writing"></g> <g id="_x30_1_chatting"></g>{" "}
				</g>
			</svg>
		),
		iconDeactive: (
			<svg
				fill="#7A7B7C"
				viewBox="0 0 64 64"
				version="1.1"
				space="preserve"
				xmlns="http://www.w3.org/2000/svg"
				xlink="http://www.w3.org/1999/xlink">
				<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					strokeLinecap="round"
					strokeLinejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<g id="_x32_5_attachment"></g> <g id="_x32_4_office"></g>{" "}
					<g id="_x32_3_pin"></g> <g id="_x32_2_business_card"></g>{" "}
					<g id="_x32_1_form"></g> <g id="_x32_0_headset"></g>{" "}
					<g id="_x31_9_video_call"></g> <g id="_x31_8_letter_box"></g>{" "}
					<g id="_x31_7_papperplane"></g> <g id="_x31_6_laptop"></g>{" "}
					<g id="_x31_5_connection"></g> <g id="_x31_4_phonebook"></g>{" "}
					<g id="_x31_3_classic_telephone"></g> <g id="_x31_2_sending_mail"></g>{" "}
					<g id="_x31_1_man_talking"></g> <g id="_x31_0_date"></g>{" "}
					<g id="_x30_9_review"></g> <g id="_x30_8_email"></g>{" "}
					<g id="_x30_7_information"></g> <g id="_x30_6_phone_talking"></g>{" "}
					<g id="_x30_5_women_talking">
						{" "}
						<g>
							{" "}
							<g>
								{" "}
								<path d="M24.8975,30.165c0.0488,0,0.0986-0.001,0.1484-0.0034c0.8809-0.0366,1.6865-0.3921,2.21-0.9751 c0.3691-0.4111,0.335-1.0435-0.0762-1.4121c-0.4111-0.3677-1.043-0.335-1.4121,0.0762c-0.1611,0.1792-0.4697,0.2988-0.8057,0.313 c-0.3975,0.02-0.7861-0.1191-1.0566-0.3726c-0.4004-0.3784-1.0342-0.3599-1.4131,0.0415 c-0.3789,0.4019-0.3604,1.0347,0.042,1.4136C23.1582,29.8345,24.0117,30.165,24.8975,30.165z"></path>{" "}
								<path d="M29.0557,22.8726c0.2705-0.2539,0.6621-0.3901,1.0576-0.3726c0.3359,0.0142,0.6436,0.1338,0.8047,0.3125 c0.1973,0.2202,0.4707,0.3325,0.7441,0.3325c0.2383,0,0.4766-0.0845,0.668-0.2554c0.4111-0.3691,0.4453-1.001,0.0762-1.4121 c-0.5225-0.5835-1.3281-0.939-2.21-0.9761c-0.9277-0.0288-1.8525,0.2949-2.5117,0.916c-0.4023,0.3789-0.4209,1.0117-0.042,1.4136 C28.0205,23.2329,28.6553,23.251,29.0557,22.8726z"></path>{" "}
								<path d="M20.1855,22.813c0.1973,0.2202,0.4707,0.332,0.7441,0.332c0.2383,0,0.4775-0.0845,0.668-0.2559 c0.4111-0.3691,0.4453-1.0015,0.0762-1.4121c-0.5244-0.584-1.332-0.9395-2.2158-0.9756 c-0.9473-0.0342-1.8516,0.2964-2.5078,0.9175c-0.4014,0.3794-0.418,1.0122-0.0391,1.4136 c0.3818,0.4019,1.0146,0.418,1.4141,0.0386c0.2666-0.2524,0.6309-0.3916,1.0518-0.3711 C19.7148,22.5137,20.0244,22.6338,20.1855,22.813z"></path>{" "}
								<path d="M45.2793,26.5942h-0.0381c-0.5527,0-0.9805,0.4478-0.9805,1s0.4658,1,1.0186,1s1-0.4478,1-1 S45.832,26.5942,45.2793,26.5942z"></path>{" "}
								<path d="M50.5283,26.5942h-0.0391c-0.5527,0-0.9805,0.4478-0.9805,1s0.4668,1,1.0195,1s1-0.4478,1-1 S51.0811,26.5942,50.5283,26.5942z"></path>{" "}
								<path d="M55.7803,26.5942h-0.0381c-0.5527,0-0.9814,0.4478-0.9814,1s0.4668,1,1.0195,1s1-0.4478,1-1 S56.333,26.5942,55.7803,26.5942z"></path>{" "}
								<path d="M59.28,20.01c-4.1-4.82-11.36-5.4-16.1801-1.3c-0.05,0.04-0.1,0.08-0.14,0.13c-1.15-4.68-3.1-9.47-6.39-12.92 C33.46,2.65,29.51,1,24.84,1C17.37,1,11.67,5.34,8.38,13.56c-3.49,8.7-3.41,20.04-1.87,21.51 c0.9384,0.8489,2.5365,1.6553,4.1448,2.2953c-8.6735,3.9588-8.6773,11.0029-8.6773,15.932V62c0,0.5522,0.4473,1,1,1H24.784 c0.001,0,0.0021,0.0005,0.0031,0.0005S46.6846,63,46.6846,63c0.5527,0,1-0.4478,1-1v-8.7026 c0-4.8027-0.0054-11.6125-8.0305-15.6208c1.2346-0.5417,2.4157-1.1508,3.2759-1.6266c1.85,1.65,4.18,2.64,6.7,2.85 c0.31,0.02,0.62,0.03,0.93,0.03c2.72,0,5.33-0.95,7.43-2.74c2.33-1.98,3.75-4.76,4-7.82C62.23,25.31,61.27,22.35,59.28,20.01z M10.6592,61v-4.8848c0-0.5522-0.4473-1-1-1s-1,0.4478-1,1V61H3.9775v-7.7026c0-5.4964,0.0034-12.2559,10.8652-15.3299 l-2.8193,5.1043c-0.2168,0.3916-0.1465,0.8799,0.1719,1.1943l3.1855,3.1494l-2.2578,5.7671 c-0.1611,0.4126-0.0322,0.8818,0.3184,1.1538L22.0166,61H10.6592z M15.2578,53.2158l2.2256-5.6846 c0.1455-0.3716,0.0557-0.7944-0.2285-1.0752l-3.1152-3.0801l2.4288-4.3976l6.3467,20.1876L15.2578,53.2158z M18.7599,34.2893 c1.8194,1.3416,3.8754,2.1711,6.0057,2.1711c1.9218,0,3.9115-0.8772,5.7386-2.2679l1.252,2.3571l-1.5366,4.8776H19.435 l-1.5521-4.937L18.7599,34.2893z M13.9375,21.4214v-3.8916c2.918-0.7085,3.6611-1.6431,4.8291-3.3809 c0.2959-0.4419,0.6221-0.9268,1.0488-1.4824c5.7842,3.3081,10.1367,4.6816,15.9268,5.0151v3.7607 c0,5.0225-5.9932,13.0181-10.9766,13.0181c-2.0349,0-4.023-0.9845-5.7318-2.5032c-0.0017-0.0017-0.0038-0.0029-0.0055-0.0046 C16.0564,29.3085,13.9375,25.0353,13.9375,21.4214z M20.0638,43.4272h9.5258l-4.7678,15.1341L20.0638,43.4272z M33.0797,39.0062 l2.4017,4.4459l-3.1201,3.084c-0.2842,0.2813-0.374,0.7041-0.2275,1.0762l2.2275,5.6846l-7.6577,5.9484L33.0797,39.0062z M45.6846,53.2974V61h-5.1035v-4.8848c0-0.5522-0.4473-1-1-1s-1,0.4478-1,1V61H27.7043l8.4744-6.5825 c0.3506-0.272,0.4795-0.7417,0.3174-1.1543l-2.2607-5.7676l3.1855-3.1479c0.3154-0.3125,0.3877-0.7959,0.1768-1.1865 l-2.8101-5.2013c0.6685,0.1884,1.2931,0.3917,1.8821,0.6069c0.0052,0.0018,0.0101,0.0038,0.0154,0.0054 C45.678,41.864,45.6846,48.1368,45.6846,53.2974z M36.9973,36.5634c-1.0552-0.3694-2.2184-0.6985-3.4925-0.9843l-1.4546-2.7385 c3.2595-3.1593,5.692-7.7846,5.692-11.3983v-4.7148c0-0.5376-0.4258-0.9795-0.9629-0.9995 c-6.1631-0.2295-10.5332-1.5957-16.6992-5.2202c-0.4209-0.2476-0.9609-0.1548-1.2734,0.2207 c-0.7725,0.9224-1.2871,1.689-1.7012,2.3052c-1.0615,1.5806-1.4189,2.1133-4.3672,2.7139 c-0.4658,0.0952-0.8008,0.5049-0.8008,0.98v4.6938c0,3.9083,2.1079,8.4235,5.2225,11.4815l-1.0725,2.6915 c-0.8946,0.2024-1.7331,0.4266-2.5178,0.6714C11.192,35.5442,8.8646,34.4692,7.93,33.66c-0.78-1.58-1.12-14,3.93-22.72 C14.91,5.67,19.28,3,24.84,3c4.1,0,7.56,1.44,10.28,4.29c3.3,3.46,5.15,8.53,6.18,13.36c-1.7,2.29-2.48,5.14-2.17,8.03 l-2.59,3.51c-0.23,0.3-0.2599,0.7-0.1,1.03c0.16,0.34,0.5,0.55,0.87,0.56l3.72,0.1c0.15,0.23,0.3199,0.45,0.49,0.66 C40.2336,35.2254,38.497,36.0573,36.9973,36.5634z M59.99,28.21c-0.1,1.27-0.44,2.47-1,3.56c-0.56,1.1-1.33,2.08-2.3,2.9 c-1.93,1.64-4.37,2.44-6.9,2.23c-1.97-0.16-3.79-0.9-5.27-2.13c-0.8106-0.6598-1.56-1.4893-2.08-2.4 c-0.18-0.29-0.49-0.46-0.83-0.47l-2.32-0.07l1.68-2.28c0.16-0.21,0.23-0.48,0.19-0.74c-0.2599-1.78-0.0099-3.55,0.69-5.14 c0.39-0.91,0.94-1.76,1.62-2.52c0.28-0.32,0.6-0.63,0.9301-0.91c3.98-3.39,9.97-2.91,13.36,1.07 C59.4,23.24,60.19,25.69,59.99,28.21z"></path>{" "}
							</g>{" "}
						</g>{" "}
					</g>{" "}
					<g id="_x30_4_calling"></g> <g id="_x30_3_women"></g>{" "}
					<g id="_x30_2_writing"></g> <g id="_x30_1_chatting"></g>{" "}
				</g>
			</svg>
		),
		text: "contact_us",
		to: "contact-us",
	},
	// Gallery
	{
		title: "Gallery",
		classsChange: "mm-collapse",
		iconActive: (
			<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					stroke-linecap="round"
					stroke-linejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<path
						d="M22 13.4375C22 17.2087 22 19.0944 20.8284 20.2659C19.6569 21.4375 17.7712 21.4375 14 21.4375H10C6.22876 21.4375 4.34315 21.4375 3.17157 20.2659C2 19.0944 2 17.2087 2 13.4375C2 9.66626 2 7.78065 3.17157 6.60907C4.34315 5.4375 6.22876 5.4375 10 5.4375H14C17.7712 5.4375 19.6569 5.4375 20.8284 6.60907C21.4921 7.27271 21.7798 8.16545 21.9045 9.50024"
						stroke="#FFFFFF"
						stroke-width="1.5"
						stroke-linecap="round"></path>{" "}
					<path
						d="M3.98779 6C4.10022 5.06898 4.33494 4.42559 4.82498 3.93726C5.76553 3 7.27932 3 10.3069 3H13.5181C16.5457 3 18.0595 3 19 3.93726C19.4901 4.42559 19.7248 5.06898 19.8372 6"
						stroke="#FFFFFF"
						stroke-width="1.5"></path>{" "}
					<circle
						cx="17.5"
						cy="9.9375"
						r="1.5"
						stroke="#FFFFFF"
						stroke-width="1.5"></circle>{" "}
					<path
						d="M2 13.9376L3.75159 12.405C4.66286 11.6077 6.03628 11.6534 6.89249 12.5096L11.1822 16.7993C11.8694 17.4866 12.9512 17.5803 13.7464 17.0214L14.0446 16.8119C15.1888 16.0077 16.7369 16.1009 17.7765 17.0365L21 19.9376"
						stroke="#FFFFFF"
						stroke-width="1.5"
						stroke-linecap="round"></path>{" "}
				</g>
			</svg>
		),
		iconDeactive: (
			<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					stroke-linecap="round"
					stroke-linejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<path
						d="M22 13.4375C22 17.2087 22 19.0944 20.8284 20.2659C19.6569 21.4375 17.7712 21.4375 14 21.4375H10C6.22876 21.4375 4.34315 21.4375 3.17157 20.2659C2 19.0944 2 17.2087 2 13.4375C2 9.66626 2 7.78065 3.17157 6.60907C4.34315 5.4375 6.22876 5.4375 10 5.4375H14C17.7712 5.4375 19.6569 5.4375 20.8284 6.60907C21.4921 7.27271 21.7798 8.16545 21.9045 9.50024"
						stroke="#7B7B7B"
						stroke-width="1.5"
						stroke-linecap="round"></path>{" "}
					<path
						d="M3.98779 6C4.10022 5.06898 4.33494 4.42559 4.82498 3.93726C5.76553 3 7.27932 3 10.3069 3H13.5181C16.5457 3 18.0595 3 19 3.93726C19.4901 4.42559 19.7248 5.06898 19.8372 6"
						stroke="#7B7B7B"
						stroke-width="1.5"></path>{" "}
					<circle
						cx="17.5"
						cy="9.9375"
						r="1.5"
						stroke="#7B7B7B"
						stroke-width="1.5"></circle>{" "}
					<path
						d="M2 13.9376L3.75159 12.405C4.66286 11.6077 6.03628 11.6534 6.89249 12.5096L11.1822 16.7993C11.8694 17.4866 12.9512 17.5803 13.7464 17.0214L14.0446 16.8119C15.1888 16.0077 16.7369 16.1009 17.7765 17.0365L21 19.9376"
						stroke="#7B7B7B"
						stroke-width="1.5"
						stroke-linecap="round"></path>{" "}
				</g>
			</svg>
		),
		text: "gallery",
		to: "gallery",
	},

	// Banners
	{
		title: "Banners",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				fill="#FFFFFF"
				version="1.1"
				id="Capa_1"
				xmlns="http://www.w3.org/2000/svg"
				xlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 35 35">
				<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					strokeLinecap="round"
					strokeLinejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<g>
						{" "}
						<g>
							{" "}
							<path d="M0,25.366h35V9.546H0V25.366z M2.121,11.667h30.758v11.578H2.121V11.667z"></path>{" "}
							<rect y="28.283" width="35" height="6.717"></rect>{" "}
							<rect width="35" height="6.717"></rect>{" "}
						</g>{" "}
					</g>{" "}
				</g>
			</svg>
		),
		iconDeactive: (
			<svg
				fill="#7B7B7B"
				version="1.1"
				id="Capa_1"
				style={{
					width: "24px",
					height: "24px",
				}}
				xmlns="http://www.w3.org/2000/svg"
				xlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 35 35">
				<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					strokeLinecap="round"
					strokeLinejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<g>
						{" "}
						<g>
							{" "}
							<path d="M0,25.366h35V9.546H0V25.366z M2.121,11.667h30.758v11.578H2.121V11.667z"></path>{" "}
							<rect y="28.283" width="35" height="6.717"></rect>{" "}
							<rect width="35" height="6.717"></rect>{" "}
						</g>{" "}
					</g>{" "}
				</g>
			</svg>
		),
		text: "banners",
		to: "/banners",
	},

	// Settings
	{
		title: "Settings",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="25"
				viewBox="0 0 24 25"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M12 15.5547C13.6569 15.5547 15 14.2115 15 12.5547C15 10.8978 13.6569 9.55469 12 9.55469C10.3431 9.55469 9 10.8978 9 12.5547C9 14.2115 10.3431 15.5547 12 15.5547Z"
					stroke="#fff"
					strokeWidth="1.5"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M2 13.4361V11.6761C2 10.6361 2.85 9.77609 3.9 9.77609C5.71 9.77609 6.45 8.49609 5.54 6.92609C5.02 6.02609 5.33 4.85609 6.24 4.33609L7.97 3.34609C8.76 2.87609 9.78 3.15609 10.25 3.94609L10.36 4.13609C11.26 5.70609 12.74 5.70609 13.65 4.13609L13.76 3.94609C14.23 3.15609 15.25 2.87609 16.04 3.34609L17.77 4.33609C18.68 4.85609 18.99 6.02609 18.47 6.92609C17.56 8.49609 18.3 9.77609 20.11 9.77609C21.15 9.77609 22.01 10.6261 22.01 11.6761V13.4361C22.01 14.4761 21.16 15.3361 20.11 15.3361C18.3 15.3361 17.56 16.6161 18.47 18.1861C18.99 19.0961 18.68 20.2561 17.77 20.7761L16.04 21.7661C15.25 22.2361 14.23 21.9561 13.76 21.1661L13.65 20.9761C12.75 19.4061 11.27 19.4061 10.36 20.9761L10.25 21.1661C9.78 21.9561 8.76 22.2361 7.97 21.7661L6.24 20.7761C5.33 20.2561 5.02 19.0861 5.54 18.1861C6.45 16.6161 5.71 15.3361 3.9 15.3361C2.85 15.3361 2 14.4761 2 13.4361Z"
					stroke="#fff"
					strokeWidth="1.5"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="25"
				viewBox="0 0 24 25"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M12 15.5547C13.6569 15.5547 15 14.2115 15 12.5547C15 10.8978 13.6569 9.55469 12 9.55469C10.3431 9.55469 9 10.8978 9 12.5547C9 14.2115 10.3431 15.5547 12 15.5547Z"
					stroke="#000"
					strokeWidth="1.5"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M2 13.4361V11.6761C2 10.6361 2.85 9.77609 3.9 9.77609C5.71 9.77609 6.45 8.49609 5.54 6.92609C5.02 6.02609 5.33 4.85609 6.24 4.33609L7.97 3.34609C8.76 2.87609 9.78 3.15609 10.25 3.94609L10.36 4.13609C11.26 5.70609 12.74 5.70609 13.65 4.13609L13.76 3.94609C14.23 3.15609 15.25 2.87609 16.04 3.34609L17.77 4.33609C18.68 4.85609 18.99 6.02609 18.47 6.92609C17.56 8.49609 18.3 9.77609 20.11 9.77609C21.15 9.77609 22.01 10.6261 22.01 11.6761V13.4361C22.01 14.4761 21.16 15.3361 20.11 15.3361C18.3 15.3361 17.56 16.6161 18.47 18.1861C18.99 19.0961 18.68 20.2561 17.77 20.7761L16.04 21.7661C15.25 22.2361 14.23 21.9561 13.76 21.1661L13.65 20.9761C12.75 19.4061 11.27 19.4061 10.36 20.9761L10.25 21.1661C9.78 21.9561 8.76 22.2361 7.97 21.7661L6.24 20.7761C5.33 20.2561 5.02 19.0861 5.54 18.1861C6.45 16.6161 5.71 15.3361 3.9 15.3361C2.85 15.3361 2 14.4761 2 13.4361Z"
					stroke="#000"
					strokeWidth="1.5"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		to: "",
		text: "settings",
		content: [
			// Company Logo
			// {
			// 	title: "Company Logo",
			// 	to: "/company-logo",
			// 	text: "company_logo",
			// },
			// Static
			{
				title: "Static",
				to: "/static",
				text: "static_pages",
			},
			// Social
			{
				title: "Social",
				to: "/social",
				text: "social",
			},
		],
	},
];
